import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14987aae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "audioRef",
  controls: "",
  preload: "meta",
  class: "audio-player"
}
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "audio-container",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
  }, [
    _createElementVNode("audio", _hoisted_1, [
      _createElementVNode("source", {
        src: _ctx.audioUrl,
        type: "audio/mpeg"
      }, null, 8, _hoisted_2)
    ], 512)
  ]))
}